import { ofType } from "redux-observable";
import { concat, from } from "rxjs";
import { filter, switchMap, take } from "rxjs/operators";
import { selectMissingRecipeCost } from "../../../../selectors/selectRecipeInfo";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { TypeActionNotEnoughResource, } from "../../../not-enough-resource/actionNotEnoughResource";
import { IdMissingResourceTypes } from "../../../not-enough-resource/IdMissingResourceTypes";
import { actionOngoingPurchaseStandardSelect } from "../../../ongoing-purchase/actionOngoingPurchase";
import { TypeActionProductionInfo } from "../actionProductionInfo";
import { pathProductionStart } from "../path/pathProductionStart";
export var epicProductionNotEnoughResources = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionProductionInfo.ProductionNotEnoughResources), switchMap(function (action) {
        var state = state$.value;
        var missingResources = selectMissingRecipeCost(state, action.recipeId, action.amount);
        return concat(from([
            actionOngoingPurchaseStandardSelect([
                {
                    missingResources: missingResources,
                    missingType: IdMissingResourceTypes.Resources,
                },
            ]),
            actionModalOpen(IdModal.NotEnoughResource),
        ]), action$.pipe(ofType(TypeActionNotEnoughResource.BuyWithGoldComplete), take(1), filter(function (notEnoughResourceAction) {
            return notEnoughResourceAction.isPurchased;
        }), switchMap(function () { return pathProductionStart(action, state$, deps); })));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/production/epics/epicProductionNotEnoughResources.ts
// module id = 1938
// module chunks = 3